import RichText from '../Shared/Tiles/RichText';
import '../TwoTabTile/TwoTabTile.scss';
import '../Shared/Tiles/ImageRichTextTile.scss';
import '../RecentActivities/RecentActivitiesTable.scss';
import { ITileActivityTab, TwoTabTile } from '../TwoTabTile/TwoTabTile';

export interface IFlexibleTwoTabTile {
  tileTitle: string;
  tileLinkURL: string;
  tileLinkText: string;
  tileLinkTarget: string;
  hideAgencyCode: boolean;
  hideAsOfDate: boolean;
  titleTab1: string;
  richTextTab1: string;
  titleTab2: string;
  richTextTab2: string;
}

export const FlexibleTwoTabTile: React.FunctionComponent<any> = (props: IFlexibleTwoTabTile | null) => {
  const tabs: ITileActivityTab[] = props
    ? [
        {
          title: props.titleTab1,
          hideAsOfDate: props.hideAsOfDate,
          body: <RichText className="two-tab-tile-tab-1-richtext" content={props.richTextTab1} />,
        },
        {
          title: props.titleTab2,
          hideAsOfDate: props.hideAsOfDate,
          body: <RichText className="two-tab-tile-tab-2-richtext" content={props.richTextTab2} />,
        },
      ]
    : [];

  return props ? (
    <TwoTabTile
      tileTitle={props.tileTitle}
      tileLinkURL={props.tileLinkURL}
      tileLinkText={props.tileLinkText}
      tileLinkTarget={props.tileLinkTarget}
      tileLinkAltText={props.tileLinkText}
      hideAgencyCode={props.hideAgencyCode}
      tabs={tabs}
    />
  ) : (
    <></>
  );
};
